import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IQuestion } from 'app/shared/model/question.model';
import { getEntities as getQuestions } from 'app/entities/question/question.reducer';
import { IQuestionMentorFeedback } from 'app/shared/model/question-mentor-feedback.model';
import { getEntity, updateEntity, createEntity, reset } from './question-mentor-feedback.reducer';

export const QuestionMentorFeedbackUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const questions = useAppSelector(state => state.question.entities);
  const questionMentorFeedbackEntity = useAppSelector(state => state.questionMentorFeedback.entity);
  const loading = useAppSelector(state => state.questionMentorFeedback.loading);
  const updating = useAppSelector(state => state.questionMentorFeedback.updating);
  const updateSuccess = useAppSelector(state => state.questionMentorFeedback.updateSuccess);

  const handleClose = () => {
    navigate('/question-mentor-feedback' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getQuestions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.updatedDate = convertDateTimeToServer(values.updatedDate);

    const entity = {
      ...questionMentorFeedbackEntity,
      ...values,
      question: questions.find(it => it.id.toString() === values.question.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          updatedDate: displayDefaultDateTime(),
        }
      : {
          ...questionMentorFeedbackEntity,
          createdDate: convertDateTimeFromServer(questionMentorFeedbackEntity.createdDate),
          updatedDate: convertDateTimeFromServer(questionMentorFeedbackEntity.updatedDate),
          question: questionMentorFeedbackEntity?.question?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.questionMentorFeedback.home.createOrEditLabel" data-cy="QuestionMentorFeedbackCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.questionMentorFeedback.home.createOrEditLabel">
              Create or edit a QuestionMentorFeedback
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="question-mentor-feedback-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.questionMentorFeedback.meetingId')}
                id="question-mentor-feedback-meetingId"
                name="meetingId"
                data-cy="meetingId"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.questionMentorFeedback.menteeId')}
                id="question-mentor-feedback-menteeId"
                name="menteeId"
                data-cy="menteeId"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.questionMentorFeedback.mentorId')}
                id="question-mentor-feedback-mentorId"
                name="mentorId"
                data-cy="mentorId"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.questionMentorFeedback.feedBack')}
                id="question-mentor-feedback-feedBack"
                name="feedBack"
                data-cy="feedBack"
                type="textarea"
              />
              <ValidatedField
                label={translate('fivePlusApp.questionMentorFeedback.createdDate')}
                id="question-mentor-feedback-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fivePlusApp.questionMentorFeedback.updatedDate')}
                id="question-mentor-feedback-updatedDate"
                name="updatedDate"
                data-cy="updatedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fivePlusApp.questionMentorFeedback.isShareFeedBack')}
                id="question-mentor-feedback-isShareFeedBack"
                name="isShareFeedBack"
                data-cy="isShareFeedBack"
                check
                type="checkbox"
              />
              <ValidatedField
                id="question-mentor-feedback-question"
                name="question"
                data-cy="question"
                label={translate('fivePlusApp.questionMentorFeedback.question')}
                type="select"
              >
                <option value="" key="0" />
                {questions
                  ? questions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/question-mentor-feedback" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default QuestionMentorFeedbackUpdate;
